import axios from 'axios'

axios.defaults.baseURL = 'https://api.bergregions.pl'

export default {
  checkIdentity: (mac, serial) => axios.get(`/api/v2/cms/init/identity/${mac}?serial=${serial}`),
  getDevice: (mac, serial) => axios.get(`/api/v1/device/${mac}?serial=${serial}`),
  setInitData: (mac, fw, appVersion, ip, model) => axios.patch(`api/v1/bhs/cms/init/signage/${mac}?frontendAppVersion=${appVersion}&lgFirmwareVersion=${fw}&ip=${ip}&tvModel=${model}`),
  postStatus: (mac, status) => axios.put(`/api/v2/bhs/cms/init/signage/${mac}/status?status=${status}`),
  getApp: mac => axios.get(`/api/v1/tv-app/device/${mac}`),
  getAppById: appId => axios.get(`/api/v1/tv-app/preview/${appId}`),
  setIdentity: data => axios.post('/api/v2/cms/init', data),
  sendScreenshot: (mac, data) => axios.put(`/api/v2/bhs/cms/init/signage/${mac}/screenshot`, data)
}
